import { connect } from 'react-redux';
import SolarInputs from './SolarInputs';

import {
    setSolarSystemSize,
    setSolarProductionRatio,
    setSolarValue,
    setSolarAnnualDeg,
    setSystemPrice,
    setInstallType,
    setInstallType2,
    setSolarPanel,
    setInverter,
    setSystemNotes,
} from '../../common/solar/actions';

import {
    setSolarInputsIsOpen,
    setSolarInputsToggle,
} from './actions';

const mapStateToProps = state => ({
    isOpen: state.solarInputsUI.isOpen,
    systemSize: state.solar.systemSize,
    productionRatio: state.solar.productionRatio,
    isLocked: state.isLockedUI.isLocked,
    solarValue: state.solar.solarValue,
    energyValue: state.utility.energyValue,
    utility: state.solarInputsUI.utility,
    annualDeg: state.solar.annualDeg,
    installType: state.solar.installType,
    installType2: state.solar.installType2,
    solarPanel: state.solar.solarPanel,
    inverter: state.solar.inverter,
    systemNotes: state.solar.systemNotes,
    solarInputsToggle: state.solarInputsUI.solarInputsToggle,
    cashprice: state.solar.cashprice,
    setSystemPrice,
    setSolarAnnualDeg,
    setSolarInputsIsOpen,
    setSolarInputsToggle,
    setSolarProductionRatio,
    setSolarValue,
    setSolarSystemSize,
    setInstallType2,
    setInstallType,
    setSolarPanel,
    setInverter,
    setSystemNotes,
});

const combinedActions = {
    setSolarInputsIsOpen,
    setSolarSystemSize,
    setSolarProductionRatio,
    setSolarValue,
    setSolarInputsToggle,
    setSolarAnnualDeg,
    setSystemPrice,
    setInstallType,
    setInstallType2,
    setSolarPanel,
    setInverter,
    setSystemNotes,
};

export default connect(mapStateToProps, combinedActions)(SolarInputs);



// WEBPACK FOOTER //
// ./src/containers/Inputs/SolarInputs/index.js